<template>
  <v-card class="p-5">
    <Link :href="item.url" class="justify-between">
      <div>{{ item.title }} <br /></div>
      <div>{{ item.searchable.email }} <br /></div>
      <div>
        <v-avatar>
          <v-img :alt="item.title" :src="item.searchable.avatar"></v-img
        ></v-avatar>
        <br />
      </div>
      <v-icon color="primary">
        mdi mdi-information-variant-circle-outline
      </v-icon>
    </Link>
  </v-card>
</template>
<script setup>
defineProps({
  item: Object,
});
</script>
